export default defineNuxtPlugin(() => {
  const { $domain } = useNuxtApp();

  if ($domain.etrackerClientId) {
    useHead({
      script: [
        {
          'src': 'https://code.etracker.com/code/e.js',
          'id': '_etLoader',
          'type': 'text/plain',
          'data-usercentrics': 'etracker',
          'data-block-cookies': true,
          'data-secure-code': $domain.etrackerClientId as string,
          'data-ecommerce-grabber': $domain.countryCode == 'DE' ? true : false,
          'data-page-changed-detection': 'url',
          'async': true,
        },
      ],
    });
  }
});
